import { render, staticRenderFns } from "./group-person.vue?vue&type=template&id=1cb44535&scoped=true"
import script from "./group-person.vue?vue&type=script&lang=js"
export * from "./group-person.vue?vue&type=script&lang=js"
import style0 from "./group-person.vue?vue&type=style&index=0&id=1cb44535&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb44535",
  null
  
)

export default component.exports